<template>

    <div class="overlay ">
        <div class="container">
            <div class="row top-row middle-xs">
                <div class="col-xs-6 col-sm-3 col-md-2">
                <img id="logo" src="@/assets/huehex-black.svg" alt="">
                </div>
                <div class="col-xs-6 col-sm-9 col-md-10 end-xs " id="menu">
                    <img  class="" @click="onClose" src="@/assets/cross.svg" alt="">
                </div>
            </div>
            <div class="row menulist middle-xs around-xs">                                       
                <div class="col-xs-6 col-md"><a @click="onClose" href="">About</a></div>
                <div class="col-xs-6 col-md"><a @click="onClose" href="#services">Services</a></div>
                <div class="col-xs-6 col-md"><a @click="onClose" href="#works">Work</a></div>
                <div class="col-xs-6 col-md"><a @click="onClose" href="">Studio</a></div>
                <div class="col-xs-6 col-md"><a @click="onClose" href="">Thoughts</a></div>
                <div class="col-xs-6 col-md"><a @click="onClose" href="">Careers</a></div>
                <div class="col-xs-6 col-md"><a @click="onClose" href="#contact">Contact</a></div>
            </div>
        </div>
    </div>
    
</template>
<script>

export default {
    props:['onClose']
}
</script>
<style lang="scss" scoped>
.overlay{
    position: fixed;
    background: $yellow;
    z-index: 999;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.top-row{
    margin-top:50px;
}
.menulist{
 height: 70vh;
 text-align: center;
 font-size: 28px;
 font-weight: 600;
 font-style: normal;
 font-stretch: normal;
 line-height: 2.19;
 letter-spacing: normal;

a{
    color: $black;
    text-decoration: none;
    position: relative;
    opacity: 0.66;
     &:after{
        content:'';
        position: absolute;
        width:0%;
        top:110%;
        left:50%;
        transition: all 0.2s;
        transform: translateX(-50%);
        height: 3px;
     }
    &:hover{
        opacity: 0.86;
       &:after{
           width:40%;
           background: $black;
       }
    }
}

}
</style>